import React from 'react';
import { GlobalConsumer } from './GlobalProvider';

// export default function withContext(Component: ComponentType) {
//   return function contextComponent(props: any): JSX.Element {
//     return (
//       <GlobalConsumer>
//         {context => <Component {...props} context={context} />}
//       </GlobalConsumer>
//     );
//   };
// }

const withContext = <P extends Record<string, unknown>, R = Omit<P, 'context'>>(
  Component: React.ComponentType<P>,
): React.FC<R> => props => (
  <GlobalConsumer>
    {value => <Component {...(props as P)} context={value} />}
  </GlobalConsumer>
);

export default withContext;
